import React from 'react';

// A screen loaded when first opened; `preload` fetches it ahead of time.
export const lazyPage = (load) => Object.assign(React.lazy(load), { preload: load });
